import { createFileRoute } from '@tanstack/react-router';
import { PayrollItemDetailLayout } from './-components/PayrollItemDetailLayout';
export const Route = createFileRoute('/_staff/payroll-engine/_layout/items/$componentId/_layout')({
  component: PayrollItemDetailLayout
});